import React, { useEffect, useState } from 'react';
import API from '../services/api';

function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [showInactive, setShowInactive] = useState(false);
  const [editForm, setEditForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    role: '',
    password: ''
  });

  const fetchUsers = async () => {
    try {
      // Always fetch all users, and filter client-side if needed
      const res = await API.get('/admin/users/all');
      
      // If showInactive is false, filter out inactive users
      if (!showInactive) {
        setUsers(res.data.filter(user => user.is_active));
      } else {
        setUsers(res.data);
      }
    } catch (err) {
      console.error(err);
      alert('Error fetching users');
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [showInactive]);

  const handleEditClick = (user) => {
    setEditingUserId(user.id);
    setEditForm({
      firstName: user.first_name,
      lastName: user.last_name,
      email: user.email,
      role: user.role,
      password: ''
    });
  };

  const handleCancelEdit = () => {
    setEditingUserId(null);
    setEditForm({
      firstName: '',
      lastName: '',
      email: '',
      role: '',
      password: ''
    });
  };

  const handleEditFormChange = (e) => {
    setEditForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSaveEdit = async (userId) => {
    try {
      await API.put(`/admin/users/${userId}`, {
        firstName: editForm.firstName,
        lastName: editForm.lastName,
        email: editForm.email,
        role: editForm.role,
        password: editForm.password || null
      });
      alert('User updated!');
      setEditingUserId(null);
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert('Error updating user');
    }
  };

  const handleDeleteUser = async (userId) => {
    if (!window.confirm('Are you sure you want to delete this user?')) {
      return;
    }
    try {
      await API.delete(`/admin/users/${userId}`);
      alert('User deleted');
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert('Error deleting user');
    }
  };

  // New function to toggle user active status
  const toggleUserStatus = async (userId, currentStatus) => {
    try {
      await API.put(`/admin/users/${userId}/active`, {
        isActive: !currentStatus
      });
      alert(currentStatus ? 'User deactivated successfully' : 'User activated successfully');
      fetchUsers();
    } catch (err) {
      console.error(err);
      alert('Error updating user status');
    }
  };

  return (
    <div>
      <h2>Manage Users</h2>
      <div style={{ marginBottom: '1rem' }}>
        <label>
          <input 
            type="checkbox" 
            checked={showInactive} 
            onChange={() => setShowInactive(!showInactive)}
          />
          Show inactive users
        </label>
      </div>
      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Role</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => {
            if (editingUserId === u.id) {
              // Editing
              return (
                <tr key={u.id}>
                  <td>
                    {u.is_active ? 'Active' : 'Inactive'}
                  </td>
                  <td>
                    <select
                      name="role"
                      value={editForm.role}
                      onChange={handleEditFormChange}
                    >
                      <option value="THERAPIST">THERAPIST</option>
                      <option value="OFFICE_ADMIN">OFFICE_ADMIN</option>
                      <option value="PORTAL_ADMIN">PORTAL_ADMIN</option>
                    </select>
                  </td>
                  <td>
                    <input
                      name="firstName"
                      value={editForm.firstName}
                      onChange={handleEditFormChange}
                    />
                  </td>
                  <td>
                    <input
                      name="lastName"
                      value={editForm.lastName}
                      onChange={handleEditFormChange}
                    />
                  </td>
                  <td>
                    <input
                      name="email"
                      type="email"
                      value={editForm.email}
                      onChange={handleEditFormChange}
                    />
                  </td>
                  <td>
                    <div>
                      <label style={{ fontSize: '0.8rem', display: 'block' }}>
                        New Password (optional):
                      </label>
                      <input
                        type="password"
                        name="password"
                        value={editForm.password}
                        onChange={handleEditFormChange}
                      />
                      <br />
                      <button onClick={() => handleSaveEdit(u.id)}>Save</button>
                      <button onClick={handleCancelEdit}>Cancel</button>
                    </div>
                  </td>
                </tr>
              );
            } else {
              // Viewing
              return (
                <tr key={u.id} style={{ opacity: u.is_active ? 1 : 0.6 }}>
                  <td>
                    <span style={{ 
                      color: u.is_active ? 'green' : 'red',
                      fontWeight: 'bold'
                    }}>
                      {u.is_active ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td>{u.role}</td>
                  <td>{u.first_name}</td>
                  <td>{u.last_name}</td>
                  <td>{u.email}</td>
                  <td>
                    <button onClick={() => handleEditClick(u)}>Edit</button>
                    <button 
                      onClick={() => toggleUserStatus(u.id, u.is_active)}
                      style={{ 
                        backgroundColor: u.is_active ? '#ffcccc' : '#ccffcc',
                        marginLeft: '5px',
                        marginRight: '5px'
                      }}
                    >
                      {u.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                    <button onClick={() => handleDeleteUser(u.id)}>Delete</button>
                  </td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
}

export default AdminUsersPage;